/** A labelled on/off switch row. Lifted from BrowserPluginSettings so the network screen
 *  and the plugin pages share one switch. */
export default function ToggleRow({
  title,
  description,
  checked,
  saving = false,
  onChange,
}: {
  title: string;
  description: string;
  checked: boolean;
  saving?: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <div className="p-4 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <div className="text-sm font-medium text-gray-900 dark:text-gray-100">{title}</div>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 leading-relaxed">{description}</p>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={saving}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${
          checked ? 'bg-green-600' : 'bg-gray-300 dark:bg-gray-600'
        }`}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
            checked ? 'translate-x-5' : 'translate-x-0.5'
          }`}
        />
      </button>
    </div>
  );
}
